import axios from '@/resources/libs/axios'

export default {
    list() {
        return axios.get(`/gei/auxiliaries/levels/level4/list/all`)
    },
}